import { AgentDashboardDataProviders, FavoriteReportsProvider } from "@buzzeasy/agent-dashboard-fragment";
import { PropsWithChildren, ReactElement } from "react";
import { useSelector } from "react-redux";
import AgentDashboardNavigationProvider from "../../components/providers/AgentDashboardNavigationContext.Provider";
import BaseProviders from "../../components/providers/BaseProviders";
import { selectAuthInfo } from "../../redux/authSlice";

/**
 * Providers for the Main app.
 */
export default function Providers({ children }: PropsWithChildren): ReactElement {
  return (
    <BaseProviders>
      <MainPageProviders>
        {children}
      </MainPageProviders>
    </BaseProviders>
  );
}

function MainPageProviders({ children }: PropsWithChildren): ReactElement {
  const { tenantId, user } = useSelector(selectAuthInfo);
  const sessionId = `${user.id}|${tenantId}`;

  return (
    <AgentDashboardDataProviders>
      <FavoriteReportsProvider sessionId={sessionId}>
        <AgentDashboardNavigationProvider>
          {children}
        </AgentDashboardNavigationProvider>
      </FavoriteReportsProvider>
    </AgentDashboardDataProviders>
  );
}
